// extracted by mini-css-extract-plugin
export default {"panel":"MainPanel_panel__buziv","inner":"MainPanel_inner__-ft40","frame":"MainPanel_frame__63q3e","ramRomSwitch":"MainPanel_ramRomSwitch__zK8c1"};